import {TNormalizedProduct} from '@/sites/purchase/typedef'

export const countAddonsTotal = (addons: Array<TNormalizedProduct>) =>
  addons.reduce(
    (accTotal, currentNumber) => accTotal + currentNumber.unit_amount,
    0
  )
